export let NavigationAction;
(function (NavigationAction) {
  NavigationAction[(NavigationAction.Previous = -1)] = 'Previous';
  NavigationAction[(NavigationAction.Next = 1)] = 'Next';
})(NavigationAction || (NavigationAction = {}));
